import { actions } from '../store/user';

const { datadogRum } = require('@datadog/browser-rum');

export default ({ env }) => {
  const isLocal = window.location.host.includes('localhost');

  if (env.config?.datadog && !isLocal) {
    datadogRum.init({
      ...env.config.datadog,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [
        (url) => url.startsWith('https://vspprd-gateway.vizzto.com.br')
      ]
    });

    actions.getUser().then((user) => {
      if (user) {
        datadogRum.setUser({
          id: user.id,
          name: user.name,
          username: user.username
        });
      }
    });
  }
};
